<template>

    <div style="height: 100%;padding: 0;margin: 0;">
      <div class="video">
        <video autoplay muted loop>
          <source src="../assets/video/nocode-auto.mp4" type="video/mp4">
        </video>

      </div>
        <h1 style="font-size: 45px;text-align: center;">{{'欢迎你！'+(user.name || '')}}</h1>
      <br>
      <br>
      <span style="font-size: 20px;color: white;">{{'你好，'+(user.name || '')+'，祝你又是开心的一天！'}}</span><br>
        <span style="font-size: 15px;" class="text2">使用粉裙星物语后台系统前请仔细阅读:<br>&emsp;&emsp;1.禁止随意删除或修改系统文件<br>&emsp;&emsp;2.禁止上架不合法的物品内容！<br>&emsp;&emsp;3.禁止进行非法操作，否则后果自负！</span>

        <ClockPanel></ClockPanel>


      <div class="center">
        <!-- 卡片头部：头像 + 昵称/角色 + 账号 -->
        <div class="profile-head">
          <el-avatar :size="88" :src="user.avatar || ''" class="profile-avatar">
            {{ (user.name || '星').slice(0, 1) }}
          </el-avatar>
          <div class="profile-head-info">
            <div class="profile-name">
              <span class="profile-name-text">{{ user.name || '未设置昵称' }}</span>
              <el-tag size="medium" :type="roleTagType" effect="light" disable-transitions>{{ roleText }}</el-tag>
            </div>
            <div class="profile-account">
              <i class="el-icon-user"></i>账号：{{ user.no }}
            </div>
          </div>
        </div>

        <div class="profile-divider"></div>

        <!-- 信息网格 -->
        <el-row :gutter="16" class="profile-grid">
          <el-col :span="8" v-for="item in infoItems" :key="item.label">
            <div class="profile-item">
              <div class="p-label"><i :class="item.icon"></i>{{ item.label }}</div>
              <el-tag v-if="item.type === 'tag'" size="small" :type="item.tagType" effect="light" disable-transitions>{{ item.value }}</el-tag>
              <div v-else class="p-value">{{ item.value }}</div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
</template>

<script>
    import ClockPanel from "./ClockPanel";
    export default {
        name: "PersonalCenter",
        components: {ClockPanel},
        data() {

            return {
                user:{}
            }
        },
        computed:{
            roleText() {
                const r = this.user.roleId
                return r === 0 ? '超级管理员' : (r === 1 ? '管理员' : '用户')
            },
            roleTagType() {
                const r = this.user.roleId
                return r === 0 ? 'warning' : (r === 1 ? 'primary' : 'info')
            },
            sexIcon() {
                return this.user.sex === 1 ? 'el-icon-male' : 'el-icon-female'
            },
            sexText() {
                return this.user.sex === 1 ? '男' : '女'
            },
            ageText() {
                const a = this.user.age
                return (a === null || a === undefined || a === '') ? '未填写' : a + ' 岁'
            },
            phoneText() {
                return this.user.phone || '未填写'
            },
            coinText() {
                const c = this.user.coin
                return (c === null || c === undefined) ? 0 : c
            },
            validInfo() {
                return this.user.isvalid === 'Y'
                    ? { text: '正常', type: 'success' }
                    : { text: '已停用', type: 'danger' }
            },
            infoItems() {
                return [
                    { icon: this.sexIcon, label: '性别', value: this.sexText },
                    { icon: 'el-icon-date', label: '年龄', value: this.ageText },
                    { icon: 'el-icon-mobile-phone', label: '电话', value: this.phoneText },
                    { icon: 'el-icon-star-on', label: '星裙币', value: this.coinText },
                    { icon: 'el-icon-s-custom', label: '角色', value: this.roleText, type: 'tag', tagType: this.roleTagType },
                    { icon: 'el-icon-circle-check', label: '账号状态', value: this.validInfo.text, type: 'tag', tagType: this.validInfo.type }
                ]
            }
        },
        methods:{
            init(){
                const cu = sessionStorage.getItem('CurUser')
                this.user = cu ? (JSON.parse(cu) || {}) : {}
            }
        },
        created(){
            this.init()
        }
    }
</script>

<style scoped>
    h1{
      color:white;
      margin-top: 25px;
    }
    .text2{
      color: rgba(73, 73, 73, 0.75);
    }
    .video{
      display: flex;
      width: 100%;
      z-index: -1;
    }
    .video video{
      right: 0;
      position: absolute;
      width: 100%;
      height: 740px;
      object-fit: cover;
      z-index: -1;
    }

    /* ===== 个人信息卡片 ===== */
    .center{
      position: absolute;
      left: 50%;
      transform: translateX(-40%);
      bottom: 70px;
      width: 820px;
      padding: 26px 30px;
      box-sizing: border-box;
      border-radius: 24px;
      background: rgba(255, 255, 255, 0.97);
      box-shadow: 0 8px 28px rgba(224, 83, 156, 0.18);
    }

    /* 卡片头部：头像 + 昵称 */
    .profile-head{
      display: flex;
      align-items: center;
    }
    .profile-avatar{
      background: linear-gradient(135deg, #ff9ec3, #f0619c);
      color: #fff;
      font-size: 34px;
      font-weight: 700;
      border: 3px solid #ffe0ef;
      flex-shrink: 0;
      box-shadow: 0 4px 14px rgba(240, 97, 156, 0.35);
    }
    .profile-head-info{
      margin-left: 22px;
    }
    .profile-name{
      display: flex;
      align-items: center;
      gap: 12px;
    }
    .profile-name-text{
      font-size: 26px;
      font-weight: 700;
      color: #c2457c;
    }
    .profile-account{
      margin-top: 10px;
      font-size: 14px;
      color: #8a6a80;
    }
    .profile-account i{
      margin-right: 4px;
      color: #e0539c;
    }

    /* 分隔线 */
    .profile-divider{
      height: 1px;
      margin: 20px 0 16px;
      background: linear-gradient(90deg, transparent, #ffd9ec, transparent);
    }

    /* 信息网格 */
    .profile-grid{
      margin-top: 2px;
    }
    .profile-item{
      background: #fff7fb;
      border: 1px solid #ffe0ef;
      border-radius: 12px;
      padding: 12px 16px;
      margin-bottom: 14px;
      transition: box-shadow 0.2s ease;
    }
    .profile-item:hover{
      box-shadow: 0 3px 10px rgba(224, 83, 156, 0.12);
    }
    .p-label{
      font-size: 13px;
      color: #b07790;
      margin-bottom: 6px;
    }
    .p-label i{
      margin-right: 4px;
      color: #e0539c;
    }
    .p-value{
      font-size: 15px;
      color: #4a2c40;
      font-weight: 600;
    }
</style>
